import { render, staticRenderFns } from "./TemplateInfoComponent.vue?vue&type=template&id=427cb484&"
import script from "./TemplateInfoComponent.vue?vue&type=script&lang=js&"
export * from "./TemplateInfoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports